import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {DceAjax} from "dce-ajax";
export interface LazyFragmentProps {
    //klasa po stronie serwera
    c: string,
    //propertiesy z serwera
    p: string,
}

@Dce("LazyFragment")
export default class LazyFragment extends DceComponent<LazyFragmentProps> {
    private loadingElement: Array<[HTMLElement, string]> = [];

    constructor(elem: DceHTMLElement, props: LazyFragmentProps) {
        super(elem, props);

        this.load();

    }

    public async load(){

        console.log("LOADING...");
        this.findLoadingElement();
        this.showLoading();

        let data = await DceAjax.getInstance().get(
            "/f/load/" + encodeURIComponent(this.props.c) + "/" + encodeURIComponent(this.props.p)
        );

        setTimeout(() => {

            let tmp;
            if (data.isValid()) {
                let v = data.data.view;

                tmp = document.createElement('div');
                tmp.innerHTML = v;

                this.elem.replaceWith(tmp.firstElementChild);
            }

        });
    }


    private findLoadingElement() {
        let foundElements = this.elem.querySelectorAll('*[data-wire-loading]');

        if (foundElements.length > 0) {
            this.loadingElement = new Array<[HTMLElement, string]>();
            foundElements.forEach(e => {
                let display = e.getAttribute('data-wire-loading');
                this.loadingElement.push(
                    [e as HTMLElement, display]
                );
            });
        }
    }

    private showLoading() {
        console.log("SHOW LOADING");

        this.loadingElement.forEach((d, index) => {
            d[0].style.display = d[1];
        });
        return;

    }

}
